/**
 * Collect unique tickers
 */
import { useEffect, useState } from 'react';
import { ITicker } from '@kattana-io/common';
import { KattanaAPI } from '../../store/createStore';

const createDictionary = (data: any[]) => {
  const dictionary: any = {};

  data.forEach((priceAlert: any) => {
    dictionary[`${priceAlert.chain}/${priceAlert.pair}`] = 1;
  });

  return Object.keys(dictionary);
};

type tickersMap = Record<string, ITicker>;

const createMergeState = async (tickers: tickersMap, tickersKeys: string[]) => {
  const newState: any = {};
  for await (const key of tickersKeys) {
    if (!tickers[key]) {
      const [chain, address] = key.split('/');
      try {
        const group = await KattanaAPI.tickers({ address });
        if (Array.isArray(group)) {
          const [item] = group;
          newState[`${item.chain}/${item.address}`] = item;
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
  return newState;
};

const useCollectTickers = (data: any) => {
  const [tickers, setTickers] = useState<tickersMap>({});
  const [loadingTickers, setLoadingTickers] = useState<boolean>(false);

  // Collect tickers
  useEffect(() => {
    let active = true;
    if (active) {
      if (!loadingTickers) {
        const keys = createDictionary(data);
        setLoadingTickers(true);
        createMergeState(tickers, keys)
          .then((merge: any) => {
            setTickers((tickers) => ({
              ...tickers,
              ...merge,
            }));
            setLoadingTickers(false);
          })
          .catch((err) => {
            setLoadingTickers(false);
          });
      }
    }

    return () => {
      active = false;
    };
  }, [data]);

  return {
    tickers,
    loadingTickers,
  };
};

export default useCollectTickers;
